import React, { FC, useMemo } from 'react';
import { Box } from '@mui/material';
import { IAnalyticsSummary, formatDuration } from './helper';
import { SingleSummaryBox } from './singleSummaryBox';
import EyeIcon from "../../../assets/eye-icon.png";
import TimeIcon from "../../../assets/time-icon.png";
import PlayIcon from "../../../assets/play-icon.png";
import ThumbsUpIcon from "../../../assets/thumbsUp-icon.png";

interface Props {
  totals: IAnalyticsSummary['totals'];
}

// The four numbers, straight from the API's totals for the window — nothing
// is filtered or summed here any more (TDC-1676). Plays now honours the date
// range like its neighbours; it used to read all-time.
export const AnalyticsSummary: FC<Props> = ({ totals }) => {
  const watchTime = useMemo(() => {
    const seconds = totals?.watch_seconds || 0;
    const plays = totals?.plays || 0;
    const { value: total, unit: totalUnit } = formatDuration(seconds);
    const { value: average, unit: averageUnit } = formatDuration(seconds / (plays || 1));
    return { total, totalUnit, average, averageUnit };
  }, [totals]);

  return (
    <Box display="grid" gap="20px" width="100%" paddingY={5} gridTemplateColumns="repeat(4, 1fr)">
      <SingleSummaryBox icon={ThumbsUpIcon} heading='Impressions' value={totals?.impressions || 0} unit='' />
      <SingleSummaryBox icon={EyeIcon} heading='Plays' value={totals?.plays || 0} unit='' />
      <SingleSummaryBox icon={TimeIcon} heading='Watch Time' value={watchTime.total} unit={watchTime.totalUnit} />
      <SingleSummaryBox icon={PlayIcon} heading='Avg Play Time' value={watchTime.average} unit={watchTime.averageUnit} />
    </Box>
  );
};
